import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { ExportToCsv } from 'export-to-csv';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  modalLoading,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDelete } from 'react-icons/md';
import Moment from "react-moment";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { FoodContext } from "../../../../../contexts/Food";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const VariationCrud = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);

  let {
    //variation
    variationList,
    setVariationList,
    setPaginatedVariation,
    variationForSearch,
    setVariationForSearch,
    setDataPaginating,
  } = useContext(FoodContext);

  // States hook here
  //new variation
  let [newVariation, setNewVariation] = useState({
    name: "",
    translated_name: "",
    sku: "",
    sorting: 0,
    edit: false,
    editSlug: null,
    uploading: false,
  });
  const [variationSort,setVariationSort] = useState({
    list: [],
    modal:false
  });

  //search result
  let [searchedVariation, setSearchedVariation] = useState({
    list: null,
    searched: false,
  });

  //csv
  const options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    filename: 'Variation',
  };
  const csvExporter = new ExportToCsv(options);
  const [uploadCsv,setUploadCsv] = useState(null);
  const [uploadCsvModal,setUploadCsvModal] = useState(false);

  //set name hook
  const handleSetNewVariation = (e) => {
    setNewVariation({ ...newVariation, [e.target.name]: e.target.value });
  };

  //Save New variation
  const handleSaveNewVariation = (e) => {
    e.preventDefault();
    setNewVariation({
      ...newVariation,
      uploading: true,
    });
    const variationUrl = BASE_URL + `/settings/new-variation`;
    let formData = new FormData();
    formData.append("name", newVariation.name);
    formData.append("translated_name", newVariation.translated_name);
    formData.append("sku", newVariation.sku);
    formData.append("sorting", newVariation.sorting);
    return axios
      .post(variationUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewVariation({
          name: "",
          translated_name: "",
          sku: "",
          sorting:0,
          edit: false,
          editSlug: null,
          uploading: false,
        });
        setVariationList(res.data[0]);
        setVariationForSearch(res.data[1]);
        setSearchedVariation({
          ...searchedVariation,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("Variation has been added"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        document.getElementById('close-btn').click();
      })
      .catch((error) => {
        setLoading(false);
        setNewVariation({
          ...newVariation,
          uploading: false,
        });
        if (error.response.data.errors) {
          if (error.response.data.errors.name) {
            error.response.data.errors.name.forEach((item) => {
              if (item === "A variation already exists with this name") {
                toast.error(
                  `${_t(t("A variation already exists with this name"))}`,
                  {
                    position: "bottom-center",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                  }
                );
              }
            });
          } else {
            toast.error(`${_t(t("Please try again"))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
          }
        }
      });
  };

  //set edit true & values
  const handleSetEdit = (id) => {
    let variation = variationForSearch.find((item) => {
      return item.id === id;
    });
    setNewVariation({
      ...newVariation,
      name: variation.name,
      translated_name: variation?.translated_name ?? "",
      sku: variation?.sku ?? "",
      sorting: variation.sorting,
      editSlug: variation.slug,
      edit: true,
    });
  };

  //update Variation
  const handleUpdateVariation = (e) => {
    e.preventDefault();
    setNewVariation({
      ...newVariation,
      uploading: true,
    });
    const variationUrl = BASE_URL + `/settings/update-variation`;
    let formData = new FormData();
    formData.append("name", newVariation.name);
    formData.append("translated_name", newVariation.translated_name);
    formData.append("sku", newVariation.sku);
    formData.append("sorting", newVariation.sorting);
    formData.append("editSlug", newVariation.editSlug);
    return axios
      .post(variationUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewVariation({
          name: "",
          translated_name: "",
          sorting:0,
          sku: "",
          edit: false,
          editSlug: null,
          uploading: false,
        });
        setVariationList(res.data[0]);
        setVariationForSearch(res.data[1]);
        setSearchedVariation({
          ...searchedVariation,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("Variation has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        document.getElementById('close-btn').click();
      })
      .catch((error) => {
        setLoading(false);
        setNewVariation({
          ...newVariation,
          uploading: false,
        });
        if (error.response.data.errors) {
          if (error.response.data.errors.name) {
            error.response.data.errors.name.forEach((item) => {
              if (item === "A variation already exists with this name") {
                toast.error(
                  `${_t(t("A variation already exists with this name"))}`,
                  {
                    position: "bottom-center",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                  }
                );
              }
            });
          } else {
            toast.error(`${_t(t("Please try again"))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
          }
        }
      });
  };

  function isCSV(contents) {
    // Basic check if it's a CSV file by checking if it contains a comma
    const rows = contents.split('\n');

    // Extract the header row (assuming it's the first row)
    const headerRow = rows[0];

    // Split the header row into individual header values
    const headers = headerRow.split(',');
    return contents.includes(',') && contents.includes('\n') && (headers.length === 3);
  }

  //csv
  const handleVariationCsv = (type) =>{
    const url = BASE_URL + `/settings/get-properties-csv/${type}`;
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if(res.data){
          csvExporter.generateCsv(res.data);
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  }

  const handleOnChange = (e) => {
    if (e.target.files[0]) {
      const fileReader = new FileReader();
      fileReader.readAsText(e.target.files[0]);
      //fileReader.readAsBinaryString(e.target.files[0]);
      fileReader.onload = (e) => {
        const contents = e.target.result;
        if(isCSV(contents)){
          const startIndex = 1; // Start index
          const lines = contents.trim().split('\n').slice(startIndex);
          const parsedData = lines.map((line)=>{
            const values = line.split(',').map(value => value.replace(/["/\r\n]/g, ''));
            return {
              id : values[0],
              name : values[1],
              sorting: values[2]
            }
          })
          setUploadCsv(parsedData);
        }else {  
          if (document.getElementById('uploadFile')) {
            document.getElementById('uploadFile').value = '';
          }
          setUploadCsv(null)
          setUploadCsvModal(false)
          toast.error("Please upload only variation csv file", {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }); 
          
        } 
      };
    }; 
  }

  const getItemStyle = (isDragging, draggableStyle) => ({
    background: isDragging ? "white" : "",
    backgroundColor: isDragging ? "white" : "",
    // styles we need to apply on draggables
    ...draggableStyle
  });

  const handleVariationCsvSubmit = (e) => {
    e.preventDefault();
    
    const url = BASE_URL +"/settings/upload-properties-csv";
    let formData = {
      type : "variation",
      items : uploadCsv
    }
    if(!uploadCsv || uploadCsv.length === 0){
      toast.error(`${_t(t("Please upload file"))}`, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return false
    }
    
    setLoading(true);
    return axios
      .post(url,formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (document.getElementById('uploadFile')) {
          document.getElementById('uploadFile').value = '';
        }
        setUploadCsv(null);
        setUploadCsvModal(false)
        setLoading(false);
        toast.success(`${_t(t("Variation file upload successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        
      })
      .catch(() => {
        setLoading(false);
        setUploadCsv(null);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  }

  //search Variation here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedVariation({ ...searchedVariation, searched: false });
    } else {
      let searchedList = variationForSearch.filter((item) => {
        let lowerCaseItemName = item.name.toLowerCase();
        return lowerCaseItemName.includes(searchInput);
      });
      setSearchedVariation({
        ...searchedVariation,
        list: searchedList,
        searched: true,
      });
    }
  };

  const handleOnDragEnd = (result) =>{
    if (!result.destination) return;

    const items = variationSort.list;
    const [reorderedItem] = variationSort.list.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setVariationSort({
      ...variationSort,
      list: items
    });
  }

  // update variation sort
  const handleUpdateVariationSort = (e) =>{
    e.preventDefault()
    let orderItem = [] 
    variationSort.list?.length && variationSort.list.forEach((item,index)=>{
      orderItem.push({
        ...item,
        sorting:index + 1
      })
    })
    const url = BASE_URL +"/settings/update-variation-sort";
    setDataPaginating(true);
    let formData = {
     sortedList:orderItem
    }
    return axios
      .post(url,formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setVariationList(res.data[0]);
        setVariationForSearch(res.data[1]);
        setSearchedVariation({
          ...searchedVariation,
          list: res.data[1],
        });
        setDataPaginating(false);
        setVariationSort({
          list:[],
          modal: false
        })
        toast.success(`${_t(t("Variation sorting has been updated successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        
      })
      .catch(() => {
        setDataPaginating(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  }

  //variation sorting
  const handleVariationSort = () =>{
    const variationSorting = variationForSearch && variationForSearch.sort((a,b)=> a.sorting - b.sorting)
    setVariationSort({
      modal: true,
      list: variationSorting
    })
  }

  //delete confirmation modal of variation
  const handleDeleteConfirmation = (slug) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary rounded"
                onClick={() => {
                  handleDeleteVariation(slug);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3 rounded" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //delete variation here
  const handleDeleteVariation = (slug) => {
    setLoading(true);
    const variationUrl = BASE_URL + `/settings/delete-variation/${slug}`;
    return axios
      .get(variationUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (res.data === "data exist") {
          setLoading(false);
          toast.error(
            `${_t(t("Please remove this variation from food item first"))}`,
            {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            }
          );
        } else {
          setVariationList(res.data[0]);
          setVariationForSearch(res.data[1]);
          setSearchedVariation({
            ...searchedVariation,
            list: res.data[1],
          });
          setLoading(false);
          toast.success(`${_t(t("Variation has been deleted successfully"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  const listDataTable = (index, item) =>{
    return (
      <tr
        className="align-middle"
        key={index}
      >
        <th
          scope="row"
          className="xsm-text text-capitalize align-middle text-center"
        >
          {index +
            1 +
            (variationList.current_page -
              1) *
              variationList.per_page}
        </th>

        <td className="xsm-text text-capitalize align-middle text-center">
          {item.id}
        </td>

        <td className="xsm-text text-capitalize align-middle text-center">
          {item.name}
        </td>

        <td className="xsm-text text-capitalize align-middle text-center">
          {item.sorting}
        </td>

        <td className="xsm-text text-capitalize align-middle text-center">
          {/* <div className="dropdown">
            <button
              className="btn t-bg-clear t-text-dark--light-40"
              type="button"
              data-toggle="dropdown"
            >
              <i className="fa fa-ellipsis-h"></i>
            </button>
            <div className="dropdown-menu">
              <button
                className="dropdown-item sm-text text-capitalize"
                onClick={() =>
                  handleSetEdit(
                    item.slug
                  )
                }
                data-toggle="modal"
                data-target="#addvariation"
              >
                <span className="t-mr-8">
                  <i className="fa fa-pencil"></i>
                </span>
                {_t(t("Edit"))}
              </button>

              <button
                className="dropdown-item sm-text text-capitalize"
                onClick={() => {
                  handleDeleteConfirmation(
                    item.slug
                  );
                }}
              >
                <span className="t-mr-8">
                  <i className="fa fa-trash"></i>
                </span>
                {_t(t("Delete"))}
              </button>
            </div>
          </div> */}
          <button
            className="btn btn-primary ml-2 rounded-sm del-btn"
            onClick={() =>
              handleSetEdit(
                item.id
              )
            }
            data-toggle="modal"
            data-target="#addvariation"                                               
          >                                                    
            <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>                                                    
          </button>
            <button
            className="btn btn-danger ml-2 rounded-sm del-btn"
            onClick={()=>handleDeleteConfirmation(item.slug)}                                                    
          >                                                    
            <MdDelete className="del-icon" />                                                    
          </button>
        </td>
        <td className="xsm-text text-capitalize align-middle text-center">
          {
            item?.sku ? (
              item.sku
            ) : "-"
          }
        </td>
        <td className="xsm-text text-capitalize align-middle text-center">
          {
            item?.created_at ? (
              <Moment format="LL">
                {item.created_at}
              </Moment>
            ) : ""
          }
        </td>

        <td className="xsm-text text-capitalize align-middle text-center">
          {
            item?.updated_at ? (
              <Moment format="LL">
                {item.updated_at}
              </Moment>
            ) : ""
          }
        </td>
      </tr>
    )
  }

  return (
    <>
      <Helmet>
        <title>{_t(t("Variations"))}</title>
      </Helmet>

      {/*upload csv Modal*/}
      <div
        className={`modal fade ${
          uploadCsvModal !== false ? "showing" : ""
        }`}
        id="addReason"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content"></div>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  if (document.getElementById('uploadFile')) {
                    document.getElementById('uploadFile').value = '';
                  }
                  setUploadCsv(null)
                  setUploadCsvModal(false)
                }}
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              <div key="fragment-food-group-1">
                <form onSubmit={handleVariationCsvSubmit} autoComplete="off">
                  <div>
                    <label htmlFor="name" className="form-label">
                      {_t(t("Upload File"))}{" "}
                      <small style={{ color: "red" }}>*</small>
                    </label>
                    <br/>
                    <input
                      type={"file"}
                      id="uploadFile"
                      name="uploadFile"
                      accept={".csv"}
                      onChange={handleOnChange}
                    />
                  </div>
                  <button
                  type="submit"
                  className="btn btn-primary xsm-text text-uppercase px-3 py-2 my-4 rounded"
                  >
                    {_t(t("Submit"))}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add modal */}
      <div className="modal fade" id="addvariation" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {!newVariation.edit
                    ? _t(t("Add new variation"))
                    : _t(t("Update variation"))}
                </h5>
              </div>
              <button
                type="button"
                id="close-btn"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              {newVariation.uploading === false ? (
                <div key="fragment-variation-1">
                  <form
                    onSubmit={
                      !newVariation.edit
                        ? handleSaveNewVariation
                        : handleUpdateVariation
                    }
                    autoComplete="off"
                  >
                    <div className="row">
                      <div className="col-8">
                        <label htmlFor="name" className="form-label">
                          {_t(t("Name"))}{" "}
                          <small className="text-danger">*</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          placeholder="e.g. small, medium, large, half, full, 1ltr, 500ml"
                          value={newVariation.name || ""}
                          required
                          onChange={handleSetNewVariation}
                        />
                      </div>
                      <div className="col-4">
                        <label htmlFor="translated_name" className="form-label">
                          {_t(t("Translated Name"))}{" "}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="translated_name"
                          name="translated_name"
                          value={newVariation.translated_name || ""}
                          onChange={handleSetNewVariation}
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-4">
                        <label htmlFor="sort" className="form-label">
                          {_t(t("Sku"))}{" "}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="sku"
                          name="sku"
                          placeholder="e.g. sm"
                          value={newVariation.sku || ""}
                          onChange={handleSetNewVariation}
                        />
                      </div>
                      <div className="col-4">
                        <label htmlFor="sort" className="form-label">
                          {_t(t("Sorting"))}{" "}
                          <small className="text-danger">*</small>
                        </label>
                        <input
                          type="number"
                          min="0"
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-", ".","ArrowUp", "ArrowDown"].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          onWheel={(e) => e.target.blur()}
                          className="form-control"
                          id="sort"
                          name="sorting"
                          placeholder="e.g. 0"
                          value={newVariation.sorting || ""}
                          required
                          onChange={handleSetNewVariation}
                        />
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className="row d-flex justify-content-end">
                        <div className="col-3">
                          <button
                            type="submit"
                            className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          >
                            {!newVariation.edit
                              ? _t(t("Save"))
                              : _t(t("Update"))}
                          </button>
                        </div>
                        <div className="col-3">
                          <button
                            type="button"
                            className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                            data-dismiss="modal"
                          >
                            {_t(t("Close"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div key="fragment2">
                  <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                  </div>
                  {modalLoading(3)}
                  <div className="mt-4">
                    <div className="row d-flex justify-content-end">
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          {!newVariation.edit ? _t(t("Save")) : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                          data-dismiss="modal"
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Add modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-table-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {/* {newVariation.uploading === true || loading === true ? (
                      tableLoading()
                    ) : ( */}
                      <div key="fragment3">
                        {/* next page data spin loading */}
                        <CustomSpinLoader loading={loading}/>
                        {/* spin loading ends */}

                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-6 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb d-flex justify-content-between align-items-center">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {!searchedVariation.searched
                                    ? _t(t("Variation List"))
                                    : _t(t("Search Result"))}
                                </span>
                              </li>
                              <div>
                                <button disabled={!variationForSearch} title="Variation Sorting" className="btn btn-secondary btn-sm text-uppercase sm-text mr-2 rounded" onClick={()=>handleVariationSort()}>Sorting</button>
                                <button title="Download variation in excel" className="btn btn-success btn-sm text-uppercase sm-text mr-2 rounded" onClick={()=>handleVariationCsv("variation")} >Export Csv</button>
                                <button title="Upload variation in excel" className="btn btn-primary btn-sm text-uppercase sm-text mr-2 rounded" onClick={()=>setUploadCsvModal(true)}>Import Csv</button>
                              </div>
                            </ul>
                          </div>
                          <div className="col-6">
                            <div className="row gx-3 align-items-center">
                              {/* Search group */}
                              <div className="col-md-9 t-mb-15 mb-md-0">
                                <div className="input-group">
                                  <div className="form-file">
                                    <input
                                      type="text"
                                      className="form-control border-0 form-control--light-1 rounded-left"
                                      placeholder={_t(t("Search")) + ".."}
                                      onChange={handleSearch}
                                    />
                                  </div>
                                  <button
                                    className="btn btn-primary rounded-right" 
                                    type="button"
                                  >
                                    <i
                                      className="fa fa-search"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </div>
                              </div>

                              {/* Add group modal trigger button */}
                              <div className="col-md-3 text-md-right">
                                <button
                                  type="button"
                                  className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                                  data-toggle="modal"
                                  data-target="#addvariation"
                                  onClick={() => {
                                    setNewVariation({
                                      ...newVariation,
                                      name: "",
                                      sku: "",
                                      sorting:0,
                                      edit: false,
                                      editSlug: null,
                                      uploading: false,
                                    });
                                  }}
                                >
                                  {_t(t("add new"))}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Table */}
                        <div className="table-responsive">
                          <table className="table table-bordered table-hover min-table-height">
                            <thead className="align-middle">
                              <tr>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("S/L"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border table_report_col"
                                >
                                  {_t(t("ID"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Name"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Sorting"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Action"))}
                                </th>

                                <th
                                  scope="col"
                                  className="table_report_col sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Sku"))}
                                </th>

                                <th
                                  scope="col"
                                  className="table_report_col sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Created"))}
                                </th>
                                <th
                                  scope="col"
                                  className="table_report_col sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Updated"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                              {!searchedVariation.searched
                                ? [
                                    variationList && [
                                      variationList.data.length === 0 ? (
                                        <tr className="align-middle">
                                          <td
                                            scope="row"
                                            colSpan="6"
                                            className="xsm-text align-middle text-center"
                                          >
                                            {_t(t("No data available"))}
                                          </td>
                                        </tr>
                                      ) : (
                                        variationList.data.map(
                                          (item, index) => {
                                            return (
                                              listDataTable(index, item)
                                            );
                                          }
                                        )
                                      ),
                                    ],
                                  ]
                                : [
                                    /* searched data, logic === haveData*/
                                    searchedVariation && [
                                      searchedVariation.list.length === 0 ? (
                                        <tr className="align-middle">
                                          <td
                                            scope="row"
                                            colSpan="6"
                                            className="xsm-text align-middle text-center"
                                          >
                                            {_t(t("No data available"))}
                                          </td>
                                        </tr>
                                      ) : (
                                        searchedVariation.list.map(
                                          (item, index) => {
                                            return (
                                              listDataTable(index, item)
                                            );
                                          }
                                        )
                                      ),
                                    ],
                                  ]}
                            </tbody>
                          </table>
                        </div>
                      </div>                    
                  </div>
                </div>
              </div>

              {/* pagination loading effect */}
              {loading === true
                ? paginationLoading()
                : [
                    // logic === !searched
                    !searchedVariation.searched ? (
                      <div key="fragment4">
                        <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              {/* pagination function */}
                              {pagination(variationList, setPaginatedVariation)}
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {showingData(variationList)}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // if searched
                      <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                        <div className="row align-items-center t-pl-15 t-pr-15">
                          <div className="col-md-7 t-mb-15 mb-md-0">
                            <ul className="t-list d-flex">
                              <li className="t-list__item no-pagination-style">
                                <button
                                  className="btn btn-primary btn-sm rounded"
                                  onClick={() =>
                                    setSearchedVariation({
                                      ...searchedVariation,
                                      searched: false,
                                    })
                                  }
                                >
                                  {_t(t("Clear Search"))}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-5">
                            <ul className="t-list d-flex justify-content-md-end align-items-center">
                              <li className="t-list__item">
                                <span className="d-inline-block sm-text">
                                  {searchedShowingData(
                                    searchedVariation,
                                    variationForSearch
                                  )}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ),
                  ]}
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
      <div
        className={`modal fade ${
          variationSort.modal ? "showing" : ""
        }`}
        id="foodItem"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md mt-0 foodSortModal">
          <div className="modal-content">
            <div className="modal-header align-items-center py-1">
              <div className="fk-sm-card__content">
               <h5>Variation Sorting</h5>
              </div>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={()=>setVariationSort((curr)=>({...curr , modal:false}))}
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
             <form onSubmit={handleUpdateVariationSort} autoComplete="off">
              <div key="fragment-food-group-1">
                {/* show form or show saving loading */}
                <div className="foodSort" >
                  <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId="listItem" trpe="group">
                    {(provided,snapshot) => (
                      <div {...provided.droppableProps} ref={provided.innerRef} >
                        {variationSort.list?.length && variationSort.list.map((item, index) => {
                          return (
                            <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                              {(provided,snapshot) => (
                                <div style={getItemStyle(
                                  snapshot.isDragging,
                                  provided.draggableProps.style
                                )} className="food_sort_name" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                  <div>
                                    {item.name}
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          );
                        })}
                        {provided.placeholder}
                      </div>
                    )}
                    </Droppable>
                  </DragDropContext>
                </div>
                <div className="m-1 d-flex justify-content-end mr-2 px-1">
                  <button disabled={loading} type="submit" className="btn btn-sm rounded btn-primary">Submit</button>
                </div>
              </div>
             </form>
            </div>
          </div>
        </div>
      </div> 
    </>
  );
};

export default VariationCrud;
